import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Buzon } from '../../../models/Buzon';
import { Participante } from '../../../models/ParticipanteType';
import { BuzonService } from '../../../services/buzon.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dlg-buzon-integrantes',
  standalone: true,
  imports: [MatDialogModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatIconModule, MatTableModule, MatTooltipModule],
  templateUrl: './dlg-buzon-integrantes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dlg-buzon-integrantes.component.scss']
})
export class DlgBuzonIntegrantesComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<DlgBuzonIntegrantesComponent>);
  readonly data = inject<{ buzon: Buzon }>(MAT_DIALOG_DATA);
  private buzonService = inject(BuzonService);
  private cdr = inject(ChangeDetectorRef);


  displayedColumns: string[] = ['titular', 'encargado', 'suscrito', 'nombre', 'cargo'];
  dataSource = new MatTableDataSource<any>([]);

  ngOnInit(): void {
    const buzon = this.data?.buzon;
    if (!buzon) {
      return;
    }

    // Use the existing search endpoint which returns responsables inside each buzon
    // Example: /rs/buzon/b?criterio=secretaria
    const criterio = buzon.cargo || buzon.departamento || buzon.id?.toString() || '';
    this.buzonService.buscarBuzon(criterio).subscribe({
      next: (res: any[]) => {
        const match = (res || []).find(r => Number(r.id) === Number(buzon.id));
        const responsables = match?.responsables || [];
        // map responsables to a consistent shape for the table
        this.dataSource.data = responsables.map((rp: any) => ({
          id: rp.codigoParticipante || rp.codigoParticipante,
          nombres: rp.participante || rp.nombres,
          cargo: rp.cargo || '',
          departamento: match?.departamento || '',
          titular: !!rp.titular,
          encargado: !!rp.encargado,
          suscrito: !!rp.suscrito,
          titulo: rp.titulo || ''
        }));
        this.cdr.detectChanges();
      },
      error: () => {
        this.dataSource.data = [];
        this.cdr.detectChanges();
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
